import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {
  selectSiteDetectionLabels
} from '../../../features/detection/detection.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { SiteDetectionLabel } from '../../../models/site-detection-label';

@Component({
    selector: 'create-detection-dialog',
    templateUrl: './create-detection.dialog.html',
    styleUrls: ['../dialog.scss'],
    standalone: false
})
export class CreateDetectionDialog {


  message:string = '';
  label: string | undefined;
  siteDetectionLabels: SiteDetectionLabel[] | undefined;

  constructor(private store: Store, public dialogRef: MatDialogRef<CreateDetectionDialog>) {
    this.initHandleSiteDetectionLabels();
  }

  private initHandleSiteDetectionLabels(): void {
    this.store.select(selectSiteDetectionLabels)
      .pipe(takeUntilDestroyed())
      .subscribe((siteDetectionLabels: SiteDetectionLabel[] | undefined) => {
        this.siteDetectionLabels = siteDetectionLabels
      });
  }
}
